import 'daterangepicker';

function Directive() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      datePickerOptions: '=',
      opens: '@'
    },
    template: `<div class="date-range-picker-single">
    <input class="form-control" type="text" />
    </div>`,
    link(scope, element) {
      scope.datePickerOptions = scope.datePickerOptions || {};

      scope.datePickerOptions.opens = 'left';
      // scope.datePickerOptions.parentEl = element;
      scope.datePickerOptions.alwaysShowCalendars = true;

      element.find('.form-control')
        .daterangepicker(scope.datePickerOptions, (start, end) => {
          scope.datePickerOptions.onDatesSelected(start, end);
        });
    }
  };
}

Directive.$inject = [];

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/dateRangePicker/index.js